import { Column, ModelBase } from 'loca-boot-core'
export class VehicleModel extends ModelBase {
  /**
   * 车型code
   */
  @Column({ name: 'model_code' })
  public modelCode!: string
}
export class ResourcesModel extends ModelBase {
  @Column()
  public id!: string

  /**
   * 资源点类型
   */
  @Column({ name: 'point_type' })
  public pointType!: string

  /**
   * 资源点子类型
   */
  @Column({ name: 'point_sub_type' })
  public pointSubType!: string

  /**
   * 资源名称
   */
  @Column()
  public name!: string

  /**
   * 资源位置
   */
  @Column()
  public location!: string

  /**
   * 地址
   */
  @Column()
  public address!: string

  /**
   * 导航距离
   */
  @Column()
  public distance!: string

  /**
   * icon
   */
  @Column()
  public icon!: string

  /**
   * 资源点类型
   */
  @Column({ name: 'type' })
  public type!: string

  /**
   * c 端可见性
   */
  @Column()
  public visible?: boolean

  /**
   * 展车试驾车
   */
  @Column({ name: 'exhibition_test_drive', childType: VehicleModel })
  public exhibitionTestDrive?: VehicleModel[]
}

export class ResourcesListModel extends ModelBase {
  @Column({ name: 'resources', childType: ResourcesModel })
  public resources?: ResourcesModel[]
}

export class RecommendModel extends ModelBase {
  @Column({ name: 'nio_store', childType: ResourcesListModel })
  public nioStore?: ResourcesListModel

  @Column({ name: 'recharge', childType: ResourcesListModel })
  public recharge?: ResourcesListModel

  @Column({ name: 'recharge|ps', childType: ResourcesListModel })
  public rechargePS?: ResourcesListModel

  @Column({ name: 'recharge|cs', childType: ResourcesListModel })
  public rechargeCS?: ResourcesListModel

  @Column({ name: 'test_drive', childType: ResourcesListModel })
  public testDrive?: ResourcesListModel

  @Column({ name: 'service_center', childType: ResourcesListModel })
  public serviceCenter?: ResourcesListModel
}
